import { Auth } from 'aws-amplify';

const getCognitoUserToken = async (): Promise<string> => {
    const session = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
};

export default getCognitoUserToken;
